export default __webpack_public_path__ + "static/media/Appropriate.b8cf9c3e.svg";